import React from 'react'
import { errorIcon } from '../assets/images'
// import './multiWallet.scss'
interface IErrorMsgModalProps {
  errorMessage: string
}

function ErrorMsgModal({ errorMessage }: IErrorMsgModalProps): JSX.Element {
  return (
    <>
      <div className="inner-content text-center">
        <span className="modal-title">
          Unable to proceed!
        </span>
        <div className="mt-50 mb-50">
          <img className="error-icon " src={errorIcon} alt="danger" />
        </div>
        <span className="error-message pb-50">{errorMessage.toString()}</span>
      </div>
    </>
  )
}

export default ErrorMsgModal
